import { render, staticRenderFns } from "./detailecompareCompanys.vue?vue&type=template&id=1b565f64&scoped=true&"
import script from "./detailecompareCompanys.vue?vue&type=script&lang=js&"
export * from "./detailecompareCompanys.vue?vue&type=script&lang=js&"
import style0 from "./detailecompareCompanys.vue?vue&type=style&index=0&id=1b565f64&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b565f64",
  null
  
)

export default component.exports